import React from 'react'
import { Platform, Text, View } from 'react-native'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import { IMAGE as IMAGE_WEB } from '@ui-kit/assets/images/index.web'
import Icon from '@ui-kit/components/Icon'
import type { TableHeaderData } from '@ui-kit/components/Table/types'

import * as styles from './styles'

interface Props {
  headerItems: TableHeaderData[]
}

const TableHeader = (props: Props) => {
  const { row, column, text, firstDummyColumn } = styles.tableHeader()
  return (
    <View className={row()}>
      <View className={firstDummyColumn()} />
      {props.headerItems.map((item) => {
        const icon = item.icon
          ? Platform.select({ web: IMAGE_WEB, default: IMAGE }).icons.medium[item.icon]
          : undefined

        return (
          <View className={column()} key={item.key}>
            {icon ? <Icon imgSrc={typeof icon === 'object' ? icon.default.src : icon} /> : null}
            <Text className={text()}>{item.title}</Text>
          </View>
        )
      })}
    </View>
  )
}

export default TableHeader
